export type QuoteStatus = 'draft' | 'awaiting_response' | 'approved' | 'changes_requested' | 'converted';

interface QuoteStatusConfig {
  label: string;
  textColorClass: string;
  description?: string;
}

export function getQuoteStatusConfig(status: string, quoteNumber?: string): QuoteStatusConfig {
  switch (status) {
    case 'draft':
      return {
        label: 'Draft',
        textColorClass: 'text-muted-foreground',
        description: quoteNumber ? `${quoteNumber} is a draft` : 'Draft quote',
      };
    case 'awaiting_response':
      return {
        label: 'Awaiting Response',
        textColorClass: 'text-blue-600 dark:text-blue-400',
        description: quoteNumber ? `${quoteNumber} awaiting client response` : 'Sent to client',
      };
    case 'approved':
      return {
        label: 'Approved',
        textColorClass: 'text-green-600 dark:text-green-400',
        description: quoteNumber ? `${quoteNumber} has been approved` : 'Client approved',
      };
    case 'changes_requested':
      return {
        label: 'Changes Requested',
        textColorClass: 'text-amber-600 dark:text-amber-400',
        description: quoteNumber ? `${quoteNumber} needs changes` : 'Client requested changes',
      };
    case 'converted':
      return {
        label: 'Converted',
        textColorClass: 'text-purple-600 dark:text-purple-400',
        description: quoteNumber ? `${quoteNumber} converted to invoice` : 'Converted to invoice',
      };
    default:
      return {
        label: status,
        textColorClass: 'text-muted-foreground',
      };
  }
}
